import { keyframes, css } from 'styled-components';
import { media } from '../../../../../../shared/lib/styles';

const getStartedInteractiveSlideIn = keyframes`
    0% {
        transform: translateY(80px);
        opacity: 0;
    }

    80% {
        transform: translateY(-15px);
        opacity: 1;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
`;

function createChildrenCSS() {
    let styles = '';

    for (let i = 2; i < 11; i += 1) {
        styles += `
       &:nth-child(${i}) {
            animation-delay: ${0.1 * (i - 1)}s;
        }
       `;
    }

    return css`
        ${styles}
    `;
}

export const animateItem = css`
    transform: translate(0, 80px);
    opacity: 0;
    animation-name: ${getStartedInteractiveSlideIn};
    animation-duration: 0.5s;
    animation-timing-function: ease-out;
    animation-iteration-count: 1;
    animation-direction: normal;
    animation-fill-mode: forwards;
    animation-play-state: running;

    ${createChildrenCSS()}

    @media ${media('small')} {
        animation-name: none;
        transform: translate(0, 0);
        opacity: 1;
    }
`;
